import { isDevelop } from './mode.ts';
import { defineRoute } from '@kestrel/router';

export const routes = [
	defineRoute({
		path: "/sandbox",
		component: () => import.meta.env.PROD ? import('./pages/404.svelte') : import('./pages/sandbox/Sandbox.svelte'),
		template: () => import.meta.env.PROD ? import('./app.html?raw') : import('./templates/sandbox_template.html?raw'),
	}),
	defineRoute({
		path: '/signup',
		component: () => import('./pages/signup/SignUp.svelte'),
		server: () => import('./pages/signup/SignUpServer.ts')
	}),
	defineRoute({
		path: '/smoke/signup',
		component: () => isDevelop() ? import('./pages/signup/SignUp.svelte') : import('./pages/404.svelte'),
		...(isDevelop() && { server: () => import('./pages/signup/SignUpServer.ts') }),
		...(isDevelop() && { template: () =>  import('./templates/assets_template.html?raw') })
	}),
	defineRoute({
		path: '/signup/registrationFlow',
		component: () => import('./pages/signup/registrationFlow/RegistrationSignUpFlow.svelte'),
		server: () => import('./pages/signup/registrationFlow/RegistrationSignUpFlowServer.ts'),
		template: () => import('./templates/focused_dialog.html?raw')
	}),
	defineRoute({
		path: '/signup/success',
		component: () => import('./pages/signup/success/SignUpSuccessBasicSheet.svelte'),
	}),
	defineRoute({
		path: '/signup/registrationFlow/success',
		component: () => import('./pages/signup/registrationFlow/success/SignUpSuccessBasicFocusDialog.svelte'),
		server: () => import('./pages/signup/registrationFlow/success/SignUpSuccessBasicFocusDialogServer.ts'),
		template: () => import('./templates/focused_dialog.html?raw')
	}),
	defineRoute({
		path: '/signup/error',
		component: () => import('./pages/signup/error/SignUpErrorBasicSheet.svelte')
	}),
	defineRoute({
		path: '/signup/registrationFlow/error',
		component: () => import('./pages/signup/registrationFlow/error/SignUpErrorBasicFocusDialog.svelte'),
		server: () => import('./pages/signup/registrationFlow/error/SignUpErrorBasicFocusDialogServer.ts'),
		template: () => import('./templates/focused_dialog.html?raw')
	}),
	defineRoute({
		path: '/signup/banner/basic',
		component: () => import('./pages/signup/banner/SignUpBanner.svelte'),
		server: () => import('./pages/signup/banner/SignUpBannerServer.ts')
	}),
	defineRoute({
		path: '/pointsInfoBannerSheet',
		component: () => import('./pages/points-info-banner/PointsInfoBannerSheet.svelte'),
		server: () => import('./pages/points-info-banner/PointsInfoBannerSheetServer.ts')
	}),
	defineRoute({
		path: '/teaser/raffle',
		component: () => import('./pages/teaser/raffle/birthday/Raffle.svelte'),
		server: () => import('./pages/teaser/raffle/birthday/RaffleServer.ts')
	}),
	defineRoute({
		path: '/entrypage',
		component: () => import('./pages/teaser/product/ProductTeaser.svelte'),
		server: () => import('./pages/teaser/product/ProductTeaserServer.ts')
	}),
	defineRoute({
		path: '/productlist',
		component: () => import('./pages/teaser/product/ProductTeaser.svelte'),
		server: () => import('./pages/teaser/product/ProductTeaserServer.ts')
	}),
	defineRoute({
		path: '/meinkonto',
		component: () => import('./pages/teaser/customer/CustomerTeaser.svelte'),
		server: () => import('./pages/teaser/customer/CustomerTeaserServer.ts')
	}),
	defineRoute({
		path: '/basket',
		component: () => import('./pages/teaser/customer/CustomerTeaser.svelte'),
		server: () => import('./pages/teaser/customer/CustomerTeaserServer.ts')
	}),
	defineRoute({
		path: '/retailerselection',
		component: () => import('./pages/teaser/article/RetailerSelectionTeaser.svelte'),
		server: () => import('./pages/teaser/article/RetailerSelectionTeaserServer.ts')
	}),
	defineRoute({
		path: '/detailview',
		component: () => import('./pages/teaser/article/DetailviewTeaser.svelte'),
		server: () => import('./pages/teaser/article/DetailviewTeaserServer.ts')
	}),
	defineRoute({
		path: '/servicepage',
		component: () => import('./pages/teaser/service-page/ServicePageTeaser.svelte'),
		server: () => import('./pages/teaser/service-page/ServicePageTeaserServer.ts')
	}),
	defineRoute({
		path: '/membership',
		component: () => import('./pages/teaser/membership/MembershipTeaser.svelte'),
		server: () => import('./pages/teaser/membership/MembershipTeaserServer.ts')
	}),
	defineRoute({
		path: '/pointsInfoBanner',
		component: () => import('./pages/points-info-banner/PointsInfoBanner.svelte'),
		server: () => import('./pages/points-info-banner/PointsInfoBannerServer.ts')
	}),
	defineRoute({
		path: '/terms-and-conditions',
		component: () => import('./pages/sheet/terms-and-conditions/TermsAndConditions.svelte')
	}),
	defineRoute({
		path: '/data-protection',
		component: () => import('./pages/sheet/data-protection/DataProtection.svelte')
	}),
	defineRoute({
		path: '/gateway/subscribe',
		methods: () => import('./api/gateway/Subscribe.ts')
	}),
	defineRoute({
		path: '/internal/health',
		methods: () => import('./api/internal/Health.ts')
	}),
	defineRoute({
		path: '/internal/info',
		methods: () => import('./api/internal/Info.ts')
	}),
	defineRoute({
		path: '/internal/prometheus',
		methods: () => import('./api/internal/Prometheus.ts')
	}),
	defineRoute({
		path: '/gateway/generateCustomerIdentityLoginUrl',
		methods: () => import('./api/gateway/GenerateCustomerIdentityLoginUrl.ts')
	}),
	defineRoute({
		path: '/gateway/generateCustomerIdentityRegistrationUrl',
		methods: () => import('./api/gateway/GenerateCustomerIdentityRegistrationUrl.ts')
	}),
	defineRoute({
		path: '/gateway/pointsInfoBannerContext',
		methods: () => import('./api/gateway/PointsInfoBannerContext.ts')
	}),
	defineRoute({
		path: '/gateway/articleTeaserContext',
		methods: () => import('./api/gateway/ArticleTeaserContext.ts')
	})
]

